module.exports = __webpack_public_path__ + "static/img/registerSuccess.654c48e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/registerSuccess.png
// module id = ZxwR
// module chunks = 1